import * as React from 'react';
import differenceWith from 'lodash/differenceWith';
import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';
import Transfer from '../../../node_modules/antd/lib/transfer';
import ReactDragListView from 'react-drag-listview';
import 'antd/lib/transfer/style/index.css';
import 'antd/lib/style/index.css';
// style dependencies
import 'antd/lib/checkbox/style/index.css';
import 'antd/lib/button/style/index.css';
import 'antd/lib/input/style/index.css';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from './PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import $ from 'jquery';
import { GridReeferStatusToolBar } from '../sharedcomponents/GridReeferStatusToolBar';
import { GridReeferHistoryToolBar } from '../sharedcomponents/GridReeferHistoryToolBar';
import { GridToolBarExcel } from './../sharedcomponents/GridToolBarExcel';
import { GridApi } from 'ag-grid-community';
/* Start WI 27261*/
import { GensetHistoryGrid } from '../childcomponents/GensetHistoryGrid';
import { ReeferHistoryGrid } from '../childcomponents/ReeferHistoryGrid';
import { DryHistoryGrid } from '../childcomponents/DryHistoryGrid';
import { ChassisHistoryGrid } from '../childcomponents/ChassisHistoryGrid';
/* End WI 27261*/
var Config: any = require('../../Config.json');

export interface GridColumnPreference {
    targetKeys: any[];
    selectedKeys: any[];
    exportColumns: any[];
    disabled: any;
    saveRowGroups: boolean;
    copyToHistory: boolean;
}
var self;
var prefChanged: boolean = false;

export class GridPreferenceControl extends React.Component<any, GridColumnPreference> {
    constructor(props: any) {
        super(props);

        this.state = {
            targetKeys: [],
            selectedKeys: [],
            exportColumns: [],
            disabled: false,
            saveRowGroups: this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false,
            copyToHistory:true
        };

        self = this;

        this.LoadDefaultGridColumns(this.props.functionId);
    }

    LoadDefaultGridColumns(functionId: any) {
        prefChanged = false;
        this.setState({ targetKeys: [], exportColumns: [], selectedKeys: [] });
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId)
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<InterfaceExportColumns[]>)
            .then(data => {
                //this.setState({ exportColumns: data });
                this.BindSavedPreferenceData(functionId, data);
            });
    }

    BindSavedPreferenceData(functionId: any, exportCols: any[]) {
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    if (preferenceData.SelectedColumnIds != null && preferenceData.SelectedColumnIds != undefined )
                        this.setState({ exportColumns: exportCols, targetKeys: preferenceData.SelectedColumnIds });
                    else {
                        var defaultKeys = exportCols.map(item => item.InterfaceExportColumnId);
                        this.setState({ exportColumns: exportCols, targetKeys: defaultKeys });
                    }
                    $('#globalLoader').hide();
                }
                else {
                    //var defaultKeys = exportCols.filter(item => item.IsRequired == true).map(item => item.InterfaceExportColumnId);
                    if (functionId == 66) {
                        var defaultKeys = exportCols.filter(x => x.ColumnNm != "TWState" && x.ColumnNm != "TWTime").map(item => item.InterfaceExportColumnId);
                        this.setState({ exportColumns: exportCols, targetKeys: defaultKeys });
                    }
                    else {
                        var defaultKeys = exportCols.map(item => item.InterfaceExportColumnId);
                        this.setState({ exportColumns: exportCols, targetKeys: defaultKeys });
                    }

                    $('#globalLoader').hide();
                }
            });    
    }

    componentDidMount() {
        var functionId = this.props.functionId;
        $("#btnArrowUp").attr('disabled', 'disabled');
        $("#btnArrowDown").attr('disabled', 'disabled');
        //this.LoadDefaultGridColumns(this.props.interfaceId);
        if (functionId == 41 || functionId == 46 || functionId == 48 || functionId == 61) { //WI 26721
            if ($("#divCopyToHistory").hasClass("hidden")) $('#divCopyToHistory').removeClass('hidden');
        }
        else {
            if (!$("#divCopyToHistory").hasClass("hidden")) $('#divCopyToHistory').addClass('hidden');
        }
    }

    componentWillReceiveProps(nextprops: any) {
        this.setState({ copyToHistory: true });
        var functionId = nextprops.functionId;
        if (functionId != undefined && functionId != null && functionId != "") {
            $("#btnArrowUp").attr('disabled', 'disabled');
            $("#btnArrowDown").attr('disabled', 'disabled');
            if (functionId == 41 || functionId == 46 || functionId == 48 || functionId == 61) { //WI 26721
                if ($("#divCopyToHistory").hasClass("hidden")) $('#divCopyToHistory').removeClass('hidden');
            }
            else {
                if (!$("#divCopyToHistory").hasClass("hidden")) $('#divCopyToHistory').addClass('hidden');
            }
            this.LoadDefaultGridColumns(functionId);
        }
    }

    HideAllGridColumns() {
        //var defaultColumns = this.state.ExportColumns;
        //var allColumnsNames = defaultColumns.map(({ ColumnNm }) => ColumnNm);      
        var defaultColumns = self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        //var allColumnsNames = defaultColumns.filter(x => x.getId());
        self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
    }

    ShowHideGridColumns(columnNames: any) {
        self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
        //$.each(columnNames, function (index, value) {
        //    self.props.gridApiParams.gridOptionsWrapper.columnApi.moveColumn(value, index);
        //});
        self.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
    }

    static StatusGridPreferenceColumns(functionId: any, gridApiParams: any, formName: any) {
        //$('#globalLoader').show();
        var dbPreID: any = 0; //RCNG 5353 Fix
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerPreferenceData?FunctionId=' + functionId + '&DashboardPreferenceId=' + dbPreID;;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                var columnNames = null;
                if (data.UserPreference != null) {
                    var preferenceData = JSON.parse(data.UserPreference);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                        var userColumnNames = preferenceData.SelectedColumnValues;
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            columnNames = userColumnNames.filter(value => -1 !== customerSelectedColumns.indexOf(value));
                        }
                        else {
                            if (data.DefaultCustomerPreference != null) {
                                var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                                var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                                //columnNames = preferenceData.SelectedColumnValues;
                                defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors).concat(data.CustomerAttributes);//WI 26721
                                columnNames = userColumnNames.filter(value => -1 !== defaultCustomerColumns.indexOf(value));
                            }
                            else
                                columnNames = preferenceData.SelectedColumnValues;
                        }

                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //var allColumnsNames = defaultColumns.map(function (v, i) { return v.colId });
                        //var customColumns = differenceWith(columnNames, allColumnsNames, isEqual);
                        //if (customColumns.length > 0) {
                        //    var selectedColumns = difference(columnNames, customColumns);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(selectedColumns, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(selectedColumns, true);
                        //}
                        //else {
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //}
                    }
                    else if (preferenceData.SelectedRowGroups != null && preferenceData.SelectedRowGroups.length >= 0) {
                        //var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(customerSelectedColumns, true);
                        }
                        else if (data.DefaultCustomerPreference != null) {
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors).concat(data.CustomerAttributes);//WI 26721
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);
                        }
                        else {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        }
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                    }
                } else if (data.CustomerPreference != null) {
                    var preferenceData = JSON.parse(data.CustomerPreference);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                        var userColumnNames = preferenceData.SelectedColumnValues;
                        columnNames = preferenceData.SelectedColumnValues;

                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);

                        //var allColumnsNames = defaultColumns.map(function (v, i) { return v.colId });
                        //var customColumns = differenceWith(columnNames, allColumnsNames, isEqual);
                        //if (customColumns.length > 0) {
                        //    var selectedColumns = difference(columnNames, customColumns);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(selectedColumns, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(selectedColumns, true);
                        //}
                        //else {
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //}
                    }
                }
                else {
                    if (functionId == 66) {
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        var reqColumns = defaultColumns.filter(x => x.colId != "TWState" && x.colId != "TWTime");

                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(reqColumns, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(reqColumns, true);
                    }
                    else {
                        //var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);  
                        if (data.DefaultCustomerPreference != null) {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors).concat(data.CustomerAttributes);//WI 26721
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);
                        }
                        else {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        }
                    }
                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                }
                if (formName == "ReeferStatusGrid") {
                    setTimeout(() => {
                        GridReeferStatusToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions)
                    }, 500);
                }
                else if (formName == "ReeferGrid") {
                    setTimeout(() => {
                        GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions)
                    }, 200);
                }
            });
    }

    static HistoryGridPreferenceColumns(functionId: any, gridApiParams: any, formName: any) {
        //$('#globalLoader').show();
        var dbPreID: any = 0;
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerPreferenceData?FunctionId=' + functionId + '&DashboardPreferenceId=' + dbPreID;;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                var columnNames = null;
                if (data.UserPreference != null) {
                    var preferenceData = JSON.parse(data.UserPreference);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {
                        var userColumnNames = preferenceData.SelectedColumnValues;
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            columnNames = userColumnNames.filter(value => -1 !== customerSelectedColumns.indexOf(value));
                        }
                        else {
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            //columnNames = preferenceData.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors);
                            columnNames = userColumnNames.filter(value => -1 !== defaultCustomerColumns.indexOf(value));
                        }

                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //var allColumnsNames = defaultColumns.filter(x => x.getId());
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //$.each(columnNames, function (index, value) {
                        //    gridApiParams.gridOptionsWrapper.columnApi.moveColumn(value, index);
                        //});
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //$('#globalLoader').hide();
                    }
                    else {
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        if (data.CustomerPreference != null) {
                            var customerPreference = JSON.parse(data.CustomerPreference);
                            var customerSelectedColumns = customerPreference.SelectedColumnValues;
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(customerSelectedColumns, true);
                        }
                        else if (data.DefaultCustomerPreference != null) {
                            var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                            var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                            defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors);
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);
                        }
                        else {
                            var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                            gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                        }
                    }
                }
                else if (data.CustomerPreference != null) {
                    var preferenceData = JSON.parse(data.CustomerPreference);
                    if (preferenceData.SelectedColumnValues != "" && preferenceData.SelectedColumnValues != null) {

                        columnNames = preferenceData.SelectedColumnValues;
                        var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        //var allColumnsNames = defaultColumns.filter(x => x.getId());
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(columnNames, 0);
                        //$.each(columnNames, function (index, value) {
                        //    gridApiParams.gridOptionsWrapper.columnApi.moveColumn(value, index);
                        //});
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(columnNames, true);
                        //$('#globalLoader').hide();
                    }
                }
                else {
                    //var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                    //gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, true);
                    ////$('#globalLoader').hide();

                    var defaultCustomerPreference = JSON.parse(data.DefaultCustomerPreference);
                    var defaultCustomerColumns = defaultCustomerPreference.SelectedColumnValues;
                    defaultCustomerColumns = defaultCustomerColumns.concat(data.DeviceSensors);
                    var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                    /*var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();*/
                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultCustomerColumns, true);

                    gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnVisible('0', false);
                }

                if (formName == "ReeferHistoryGrid") {
                    setTimeout(() => {
                        GridReeferHistoryToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions)
                    }, 200);
                }
                else if (formName == "ReeferHistory") {
                    setTimeout(() => {
                        GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions)
                    }, 200);
                }
            });
    }
    ResetGridPreferences() {
        var data = this.state.exportColumns;
        //var defaultKeys = data.filter(item => item.IsRequired == true).map(item => item.InterfaceExportColumnId);
        var defaultKeys = data.map(item => item.InterfaceExportColumnId);
        this.setState({ targetKeys: defaultKeys, exportColumns: data, selectedKeys: [] });
    }

    static ResetGridColumns(functionId: any, gridApiParams: any, formName: any) {
        $('#globalLoader').show();
        var exportColumns = null;
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId)
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<InterfaceExportColumns[]>)
            .then(data => {

                var defaultColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);

                var exportColumns = data;
                var selectedColumns = [];
                var selectedColumnsIds = [];
                var saveRowGroups = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0
                $.each(exportColumns, function (index, value) {
                    if (data.length > 0) {
                        var preferenceColumnNames = data[index].ColumnNm;
                        var preferenceColumnIds = data[index].InterfaceExportColumnId;
                        selectedColumnsIds.push(preferenceColumnIds);
                        selectedColumns.push(preferenceColumnNames);
                    }
                });

                var rowGroupedArray = [];
                if (saveRowGroups) {
                    if (gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns() != null && gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0) {
                        for (var i = 0; i < gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length; i++) {
                            // Validation 
                            if (selectedColumns.indexOf(gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId) !== -1) {
                                rowGroupedArray.push(gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId)
                            }
                        }
                    }
                }
                var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                var data1 = { SelectedColumnIds: selectedColumnsIds, SelectedColumnValues: selectedColumns, SelectedRowGroups: rowGroupedArray };
                //var data = { SelectedColumnIds: self.state.targetKeys, SelectedColumnValues: selectedColumns };
                var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(data1), CopyToHistory: false };//WI 26721
                var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json())
                    .then(data => {
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.moveColumns(selectedColumns, 0);
                        gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(selectedColumns, true);

                        if (formName == "ReeferStatusGrid")
                            GridReeferStatusToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "ReeferGrid")
                            GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "ReeferHistoryGrid")
                            GridReeferHistoryToolBar.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);
                        else if (formName == "ReeferHistory")
                            GridToolBarExcel.GetColumns(gridApiParams.gridOptionsWrapper.gridOptions);

                        $('#globalLoader').hide();
                    });
            });
    }

    SaveGridPreferences() {
        if (self.state.targetKeys.length == 0)
            PopupWindow.showErrorMessage("Alert", "Please select at least one column to save grid preference.");
        else {
            var selectedCols = this.state.selectedKeys;
            if (selectedCols.length > 0 && prefChanged) {
                RCNGWindow.ConfirmWindow.showConfirmBox('Columns are selected. Do you want to save the changes?', this.onOKSubmit.bind(this), this.closeConfirmation.bind(this));
            }
            else if (selectedCols.length > 0 && !prefChanged) {
                RCNGWindow.ConfirmWindow.showConfirmBox('Columns are selected. Do you want to save without any changes?', this.onOKSubmit.bind(this), this.closeConfirmation.bind(this));
            }
            else {
                this.onOKSubmit();
            }
        }
    }

    onOKSubmit() {
        if (self.state.targetKeys.length > 0) {
            RCNGWindow.ConfirmWindow.close();
            $('#globalLoader').show();
            this.HideAllGridColumns();

            var defaultColumns = this.state.exportColumns;
            var selectedColumnIds = self.state.targetKeys;
            var selectedColumns = [];
            //var rows = this.props.gridApiParams.gridOptionsWrapper.columnApi.getRowGroupColumns().slice();
            $.each(selectedColumnIds, function (index, value) {
                var data = defaultColumns.filter(x => x.InterfaceExportColumnId == parseInt(value));
                if (data.length > 0) {
                    var preferenceColumns = data[0].ColumnNm;
                    selectedColumns.push(preferenceColumns);
                }
            });
            var rowGroupedArray = [];
            if (this.state.saveRowGroups) {
                if (this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns() != null && this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0) {
                    for (var i = 0; i < this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length; i++) {
                        // Validation 
                        if (selectedColumns.indexOf(this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId) !== -1) {
                            rowGroupedArray.push(this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns()[i].colId)
                        }
                    }
                }
            }

            var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
            var data = { SelectedColumnIds: self.state.targetKeys, SelectedColumnValues: selectedColumns, SelectedRowGroups: rowGroupedArray };
            //var data = { SelectedColumnIds: self.state.targetKeys, SelectedColumnValues: selectedColumns };
            var preferencedata = { UserId: 0, FunctionId: this.props.functionId, PreferenceData: JSON.stringify(data), CopyToHistory: self.state.copyToHistory }; //WI 26721
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    this.ShowHideGridColumns(selectedColumns);
                    this.props.closeModelDialog();
                    if (self.props.formname == "ReeferStatusGrid") {
                        GridReeferStatusToolBar.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                        //ReeferHistoryGrid.GetReeferHistoryGridPrefColumns(preferencedata);  //WI 26721
                    }
                    else if (self.props.formname == "ReeferGrid")
                        GridToolBarExcel.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                    else if (self.props.formname == "ReeferHistoryGrid")
                        GridReeferHistoryToolBar.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                    else if (self.props.formname == "ReeferHistory")
                        GridToolBarExcel.GetColumns(this.props.gridApiParams.gridOptionsWrapper.gridOptions);
                    //else if (self.props.formname == "GensetStatusGrid")  //WI 26721
                    //    //GensetHistoryGrid.GetGensetHistoryGridPrefColumns(preferencedata);
                    //else if (self.props.formname == "DryStatusGrid")  //WI 26721
                    //    //DryHistoryGrid.GetDryHistoryGridPrefColumns(preferencedata);
                    //else if (self.props.formname == "ChassisStatusGrid")  //WI 26721
                    //    ChassisHistoryGrid.GetChassisHistoryGridPrefColumns(preferencedata);
                    $('#globalLoader').hide();
                });
        }
        else
            PopupWindow.showErrorMessage("Alert", "Please select at least one column to save grid preference.");
    }

    closeConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    CancelAction() {
        this.props.closeModelDialog();
    }

    handleChange(nextTargetKeys) {
        this.setState({ targetKeys: nextTargetKeys });
    }


    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.setState({
            selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys]
        });

        var targetSelected = [...targetSelectedKeys];
        var sourceSelected = [...sourceSelectedKeys];

        if (targetSelected.length == 1 && sourceSelected.length == 0) {
            $("#btnArrowUp").removeAttr('disabled');
            $("#btnArrowDown").removeAttr('disabled');
        }
        else {
            $("#btnArrowUp").attr('disabled', 'disabled');
            $("#btnArrowDown").attr('disabled', 'disabled');
        }

    }

    arrowMoveUp() {
        var selectedKeys = self.state.selectedKeys;
        var targetKeys = [...self.state.targetKeys];
        var fromIndex: number;
        var toIndex: number;
        for (var i = 0; i < targetKeys.length; i++) {
            if (targetKeys[i] == selectedKeys[0]) {
                if (i > 0) {
                    prefChanged = true;
                    fromIndex = i;
                    toIndex = i - 1;
                    break;
                }
                else
                    return;
            }
        }

        var item = targetKeys.splice(fromIndex, 1)[0];
        targetKeys.splice(toIndex, 0, item);

        self.handleChange(targetKeys);
    }

    SaveRowGroupsChange = () => {
        this.setState({
            saveRowGroups: !this.state.saveRowGroups,
        });
    }


    arrowMoveDown() {
        var selectedKeys = self.state.selectedKeys;
        var targetKeys = [...self.state.targetKeys];
        var fromIndex: number;
        var toIndex: number;
        for (var i = 0; i < targetKeys.length; i++) {
            if (targetKeys[i] == selectedKeys[0]) {
                if (i == (targetKeys.length - 1))
                    return;
                else {
                    prefChanged = true;
                    fromIndex = i;
                    toIndex = i + 1;
                    break;
                }
            }
        }

        var item = targetKeys.splice(fromIndex, 1)[0];
        targetKeys.splice(toIndex, 0, item);

        self.handleChange(targetKeys);
    }

    onCopyToHistoryCheck(event: React.FormEvent<HTMLInputElement>) {  //WI 26721        
        this.setState({ copyToHistory: event.currentTarget.checked });
    }

    public render() {
        var { targetKeys, selectedKeys, disabled} = this.state;
        //var rowGroupLength = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length;
        var chkboxCss: any = { 'margin-left': '35px', 'position': 'relative', 'font-size': '15px', 'font-weight': 'bold' };
        var defaultColumns = this.state.exportColumns;
        var dataSource = [];
        if (defaultColumns != undefined && defaultColumns != null && defaultColumns.length > 0) {
            dataSource = defaultColumns.map(function (col) {
                return (
                    { key: col.InterfaceExportColumnId, title: col.ColumnDisplayNm, disabled: col.IsRequired }
                );
            });
        }
        // Code for drag functionality, this will work once you press ctrl+F5.
        var getDragProps = () => ({
            onDragEnd: (fromIndex, toIndex) => {
                var targetKeys = [...self.state.targetKeys];
                var item = targetKeys.splice(fromIndex, 1)[0];
                targetKeys.splice(toIndex, 0, item);

                self.handleChange(targetKeys);
            },
            nodeSelector: ".ant-transfer-list:last-child .ant-transfer-list-content > div"
        });

        var filterOption = (inputValue, option) => option.title.toUpperCase().indexOf(inputValue.toUpperCase()) > -1;

        return <div>
            <div>
                <ReactDragListView {...getDragProps() }>
                    <Transfer
                        dataSource={dataSource}
                        showSearch
                        filterOption={filterOption}
                        titles={["All Columns / Not Displayed", "Selected Columns / Displayed"]}
                        targetKeys={targetKeys}
                        selectedKeys={selectedKeys}
                        disabled={disabled}
                        onChange={this.handleChange.bind(this)}
                        onSelectChange={this.handleSelectChange.bind(this)}
                        render={item => item.title}
                        listStyle={{ height: 430 }}
                    ></Transfer>
                </ReactDragListView>
            </div>
            <div className="ant-transfer-operation draggableposition">
                <button type="button" id="btnArrowUp" className="ant-btn ant-btn-primary ant-btn-sm" onClick={this.arrowMoveUp.bind(this)}>
                    <span>
                        <i className="fas fa-chevron-up"></i>
                    </span>
                </button>
                <button type="button" id="btnArrowDown" className="ant-btn ant-btn-primary ant-btn-sm" onClick={this.arrowMoveDown.bind(this)}>
                    <span>
                        <i className="fas fa-chevron-down"></i>
                    </span>
                </button>
            </div>
            <div className="checkbox" id='divCopyToHistory' style={chkboxCss}>{/*WI 26721*/}
                <input type="checkbox" className='checkbox15' name="CopyToHistory" checked={this.state.copyToHistory} onChange={this.onCopyToHistoryCheck.bind(this)} /> <span className='CopyToHistory'>Copy To History</span>
            </div>
            <div className="modal-footer ">
                <button type="button" className="btn btn-secondary" onClick={this.CancelAction.bind(this)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.SaveGridPreferences.bind(this)}>Save</button>
                <button type="button" className="btn btn-primary" onClick={this.ResetGridPreferences.bind(this)}>Reset</button>
                
            </div>
        </div>;
    }
}

interface InterfaceExportColumns {
    InterfaceExportColumnId: number;
    ColumnNm: string;
    ColumnDisplayNm: string;
    FunctionId: number;
}
